<template lang="html">
    <section class="list-details-order">
        <div class="list-details-order-bloc">
            <h3>{{ $t("orders.orderWindow.titleOrderLink") }}</h3>
            <div v-if="!orderWindow.length" class="orderWindowEmpty">{{ $t("orders.orderWindow.msgEmptyOrder") }}</div>
            <table class="table table-header" v-if="orderWindow.length">
                <thead>
                    <tr>
                        <th scope="col">{{ $t("orders.orderWindow.orderId") }}</th>
                        <th scope="col">{{ $t("orders.orderWindow.buyer") }}</th>
                        <th scope="col">{{ $t("orders.orderWindow.status") }}</th>
                        <th scope="col">{{ $t("orders.orderWindow.lastUpdate") }}</th>
                    </tr>
                </thead>
                <tr v-for="item in orderWindow" :key="item.id">
                    <td>
                        <router-link :to="{ name: 'MyOrder', params: { id: item.id } }">{{ item.reference }}</router-link>
                    </td>
                    <td>{{ item.createdBy.firstname }} {{ item.createdBy.lastname }}</td>
                    <td>{{ getTranslate(item.status.name) }}</td>
                    <td>{{ item.modifiedDate }}</td>
                </tr>
            </table>
        </div>
    </section>
</template>

<script lang="js">
  export default  {
    name: 'list-details-order',
    props: ["orderWindow"]
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";
.list-details-order {
    @extend %second-text;
    @extend %primary-background;
    &-bloc {
        border: 1px solid var(--color4);
        .orderWindowEmpty {
            text-align: center;
            font-size: 14px;
            font-family: "oswald-regular", sans-serif;
            padding: 10px 0;
        }
    }
    h3 {
        color: #fff;
        font-family: "oswald-regular", sans-serif;
        background-color: $color4;
        text-transform: uppercase;
        padding: 20px;
        margin: 0;
    }
    & .table-header {
        text-align: left;
        padding: 15px;
        thead {
            tr {
                th {
                    font-family: "oswald-regular", sans-serif;
                    padding-left: 0;
                    padding-right: 0;
                    border: none;
                    text-transform: uppercase;
                    border-bottom: 1px solid #dee2e6;
                }
            }
        }
        td {
            font-family: "oswald-regular", sans-serif;
            border-top: none;
            a {
                color: $color4;
                text-decoration: none;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// listDetailsOrder.vue?1b0c9f29